<template>
  <div>
    <Hero
      class="hero"
      heading="Templates"
      tagline="Some help to get things straight"
    />
    <div class="action-bar-container">
      <EditToggle v-if="hasEditTogglePermissions" :callback="editToggle" class="edit-toggle" />
    </div>
    <div
      v-for="(topicData, topicKey) in mappedFiles"
      :key="topicKey"
      class="topic-container"
    >

      <div :id="'anchor-' + topicKey" class="header-container">
        <div class="header-topic-container">
          <h2 v-html="topicData.displayName" />
          <div
            v-if="hasCreatePermissions"
            @click="showModal[topicKey].create = true"
            class="icon new-icon">
          </div>
        </div>
        <TextBlock v-if="topicData.description" v-html="topicData.description" />
      </div>

      <Modal
        title="Upload File"
        :show="showModal[topicKey].create"
        @close="showModal[topicKey].create = false">
        <FileUploaderMultiple
          :files="[{ accepts: '.zip',  required: true }]"
          :topicKey="topicKey"
          :securityLevel="'private'"
          :isReplace=false
          :unionHash="generateHash(12)"
          :successCallback="filesUpdate"
        >
        </FileUploaderMultiple>
      </Modal>

      <div class="surround-all-containers">
        <div
          v-for="file in topicData.files"
          :key="file.key"
          class="files-container"
        >
          <DownloadButtonBlob
            class="btn"
            :file="file"
            :topicKey="topicKey"
            :securityLevel="'information'"
            :accepts="'.zip'"
            :hasEditPermissions="hasEditPermissions"
            :hasReplacePermissions="hasReplacePermissions"
            :hasDeletePermissions="hasDeletePermissions"
            :deleteCallback="filesUpdate"
            :replaceCallback="filesUpdate"
            :editCallback="filesUpdate"
          >
            {{ file.alias }}
          </DownloadButtonBlob>
        </div>
      </div>
    </div>
    <ViLinks />
  </div>
</template>
<script>
import Hero from '@/components/hero.vue';
import TextBlock from '@/components/text-block.vue';
import ViLinks from '@/components/visual-id-links.vue';
import EditToggle from '@/components/edit-toggle.vue';
import Modal from '@/components/modal.vue';
import FileUploaderMultiple from '@/components/file-uploader-multiple.vue';
import DownloadButtonBlob from '@/components/download-button-blob.vue';

import DeleteObjects from '@/handlers/deleteObjects';

import generateRandomHash from '@/utils/generateRandomHash';

import MixinPermissions from '@/mixins/mixin-permissions';
import MixinFileListing from '@/mixins/mixin-file-listing';

export default {
  name: 'Templates2',
  components: {
    Hero,
    TextBlock,
    ViLinks,
    EditToggle,
    Modal,
    FileUploaderMultiple,
    DownloadButtonBlob,
  },
  mixins: [
    MixinPermissions,
    MixinFileListing(
      {
        templates: {
          displayName: 'Some help to get things straight',
          files: [],
          description: `These templates are not complete. No template ever
        has done all the work, so please add, collaborate and
        share your slides with co-workers, but also keep each
        other in line so it doesn't get out of hand.`,
        },
      },
      'private',
      '',
    ),
  ],
  data() {
    return {
      securityLevel: 'private',
      editMode: false,
      showModal: {},
      mappedFiles: {},
    };
  },
  watch: {
    files: {
      deep: true,
      handler() {
        this.mapFiles();
      },
    },
    mappedFiles: {
      deep: true,
      handler() {
        this.initializeShowModal();
      },
    },
  },
  methods: {
    download(url) {
      window.open(url);
    },
    editToggle(onOrOff) {
      this.editMode = onOrOff;
    },
    fileMapper(files) {
      const mappedFiles = {};
      Object.keys(files).forEach((topicKey) => {
        mappedFiles[topicKey] = {
          ...files[topicKey],
        };
      });

      return mappedFiles;
    },
    mapFiles() {
      this.$set(this, 'mappedFiles', this.fileMapper(this.files));
    },
    initializeShowModal() {
      Object.keys(this.mappedFiles).forEach((topicKey) => {
        const replace = {};
        const remove = {};
        this.mappedFiles[topicKey].files.forEach((file) => {
          replace[file.key] = false;
          remove[file.key] = false;
        });
        this.$set(this.showModal, topicKey, {
          replace,
          remove,
          create: false,
        });
      });
    },
    generateHash(length) {
      return generateRandomHash(length);
    },
    filesUpdate() {
      // function can be found found in mixin-file-listing.js
      this.generateFilelist();
    },
    deleteFiles(file, topicKey) {
      const deleteFileKeys = [];
      deleteFileKeys.push(file.key);
      this.files[topicKey].files.forEach((unionFile) => {
        if (unionFile.metadata && unionFile.metadata.unionHash === file.metadata.unionHash) {
          deleteFileKeys.push(unionFile.key);
        }
      });

      DeleteObjects(deleteFileKeys, this.filesUpdate);
    },
  },
};
</script>


<style lang="stylus" scoped>
@require '../style/colors'
  .surround-all-containers
    display: flex
    flex-wrap: wrap
    justify-content: center
    gap: 1.5rem
    max-width: 80rem
    margin: -4rem auto 8rem auto
    padding: 0 2rem

    .files-container
      width: 100%
  .comingSoon
    display: block
    margin: 8rem 0
    text-align: center

  p
    max-width: 70rem
    margin: 0 auto
    padding: 0 2rem
    font-size: 4rem
    color: $primary-color

    @media only screen and (max-width: 600px)
      font-size: 3rem
      padding: 3rem

  .hero
    margin-bottom: 30px

  .download-links
    display: flex
    flex-direction: column
    padding: 0 60px
    max-width: 100rem
    justify-content: center
    margin: 0 auto 30px auto
  .btn
    margin-top: 20px

  .topic-container
    margin: 10px 0 0 0

  .header-container
    display: flex
    flex-direction: column
    align-items: center
    width: 100%

    .header-topic-container
      display: grid
      grid-template-columns: 1fr 1fr 1fr
      justify-items: center
      align-items: center
      gap: 5rem

      h2
        grid-column: 2
        text-align: center

      .icon
        position: relative
        width: 2.5rem
        height: 2.5rem
        cursor: pointer
      .new-icon
        background: url('../assets/addButton.svg') no-repeat
        background-size: contain
        grid-column: 3
        justify-self: start

      .icon:hover
        cursor: pointer

  .action-bar-container
    display: grid
    grid-template-columns: 1fr 1fr 1fr
    justify-items: center
    align-items: center
    margin-bottom: 2rem
    gap: 4rem

    .edit-toggle
      grid-column: 3
      justify-self: end
      align-self: flex-start

  .tag-container
    display: flex
    flex-flow: row nowrap
    justify-content: flex-start

    .tag
      font-size: 1.5rem
      color: $black30

  .filter-contianer
    display: flex
    flex-flow: row nowrap
    justify-content: flex-start
    align-items: center
    gap: 1.5rem

    select
      display: flex
      flex-flow: row nowrap
      justify-content: flex-end
      font-size: 1.5rem
      background-color: $secondary-color
      color: $primary-color
      border-color: $secondary-color
      border-radius: 2rem
      font-weight: 900
      padding: .7rem .7rem .7rem 1.2rem
      text-align: right
      border-right: 1rem solid transparent

      &:disabled
        color: $black60
        background-color: $black30
        border-color: $black30


</style>
